module.exports = __webpack_public_path__ + "media/images/emoticons/weep-4c01f89dbcf66f6d2f299ae06529127a.gif";